import type { NamedFieldProps } from "./Field.js";
import { OptionalSchema, TimeSchema, getOptionalSource, getOptionalTime, getSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function TimeField(props: NamedFieldProps): React.ReactElement {
	const field = useField(props);
	const { name, form, schema, fullplaceholder, value } = field;
	const { min, max, step } = getSource(TimeSchema, schema);
	const time = getOptionalTime(value);
	const required = !getOptionalSource(OptionalSchema, schema);
	const onValue: React.FormEventHandler<HTMLInputElement> = ({ currentTarget }) => form.publish(name, currentTarget.value);
	return (
		<Field {...field}>
			<input
				name={name}
				type="time"
				className="input space-none"
				placeholder={fullplaceholder}
				defaultValue={time?.long}
				required={required}
				min={min?.long}
				max={max?.long}
				// Divide by 1000 because `TimeSchema` is stepped in milliseconds but browsers step in seconds.
				// Default to stepping by 60 seconds (i.e. minutes) because this is the browser default/
				// Stepping by more than 60 seconds will hide the seconds portion of the input.
				// Stepping by less than 1 second will show the milliseconds portion of the input.
				step={step !== undefined ? step / 1000 : 60}
				onInput={onValue}
				onChange={onValue}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}
